// Logique pure de l'etat onboarding local-first (aucune dependance Vue/Firebase).
// La regle de vote replique lib/profileVoteAlgo.applyVoteToProfile cote local.

// propagationFree : marqueur des clients actuels (un vote plat n'est plus recopie
// sur ses ingredients). Il protege les refus deliberes du nettoyage des anciennes
// propagations (dropPropagatedBlocks, trigger onProfileCreatedTastes, migration).
export function emptyBlockPreferences() {
  return { dishLikes: [], dishDislikes: [], likes: [], dislikes: [], neutral: [], lowRatedDishes: [], votesCount: 0, lastQuizAt: null, propagationFree: true };
}

// Preferences d'un invite completees des listes manquantes. Le marqueur n'est
// JAMAIS invente pour un invite de l'ancien onboarding (donnees propagees) : il
// n'est vrai que s'il l'etait deja, ou pour un profil sans preferences.
function _guestBp(profile) {
  const own = profile && profile.blockPreferences;
  if (!own) return emptyBlockPreferences();
  return { ...emptyBlockPreferences(), ...own, propagationFree: own.propagationFree === true };
}

export function emptyGuestProfile({ key, name, regime = 'Omnivore', isDefault = false, ageGroup = 'adult' } = {}) {
  return {
    key,
    name: name || 'Moi',
    regime,
    allergies: {},
    aversions: '',
    ageGroup,
    tastePicks: {},
    blockPreferences: emptyBlockPreferences(),
    avatarUrl: '',
    avatarIcon: '',
    avatarColor: '',
    isDefault
  };
}

export function emptyState() {
  return { introSeen: false, guestProfiles: [], orderDraft: { mealsByProfileKey: {}, extras: [] } };
}

function _add(arr, id) { return arr.includes(id) ? arr : [...arr, id]; }
function _rm(arr, id) { return arr.filter((x) => x !== id); }

// Applique un vote au profil (immutable). Renvoie un nouveau profil.
export function applyGuestVote(profile, { kind, itemId, vote, dishBlockIds = [] }) {
  const bp = _guestBp(profile);
  // copies
  let { dishLikes, dishDislikes, likes, dislikes, neutral, lowRatedDishes } = bp;
  dishLikes = [...dishLikes]; dishDislikes = [...dishDislikes];
  likes = [...likes]; dislikes = [...dislikes]; neutral = [...(neutral || [])];
  lowRatedDishes = [...(lowRatedDishes || [])];

  if (kind === 'dish') {
    // Un « j'aime » leve aussi la mauvaise note, comme applyVoteToProfile.
    if (vote === 'like') { dishLikes = _add(dishLikes, itemId); dishDislikes = _rm(dishDislikes, itemId); lowRatedDishes = _rm(lowRatedDishes, itemId); }
    else { dishDislikes = _add(dishDislikes, itemId); dishLikes = _rm(dishLikes, itemId); }
    // dishBlockIds n'est plus propagé : les ingrédients se déduisent via tasteResolver (règle des 2/3).
  } else { // block : signal explicite, leve une eventuelle neutralisation
    neutral = _rm(neutral, itemId);
    if (vote === 'like') { likes = _add(likes, itemId); dislikes = _rm(dislikes, itemId); }
    else { dislikes = _add(dislikes, itemId); likes = _rm(likes, itemId); }
  }

  return {
    ...profile,
    blockPreferences: {
      ...bp,
      dishLikes, dishDislikes, likes, dislikes, neutral, lowRatedDishes,
      votesCount: (bp.votesCount || 0) + 1,
      lastQuizAt: bp.lastQuizAt
    }
  };
}

// Correction manuelle du sens d'un bloc (editeur de gouts). Immutable.
// sense: 'like' | 'dislike' | 'neutral'. Ne touche pas votesCount : une
// correction n'est pas un vote de quiz.
export function applyGuestBlockSense(profile, { blockId, sense }) {
  const bp = _guestBp(profile);
  let likes = _rm([...bp.likes], blockId);
  let dislikes = _rm([...bp.dislikes], blockId);
  let neutral = _rm([...(bp.neutral || [])], blockId);
  if (sense === 'like') likes = _add(likes, blockId);
  else if (sense === 'dislike') dislikes = _add(dislikes, blockId);
  else if (sense === 'neutral') neutral = _add(neutral, blockId);
  return { ...profile, blockPreferences: { ...bp, likes, dislikes, neutral } };
}

// Correction d'un vote plat invité (retrait depuis « On ne te servira jamais »).
export function applyGuestDishSense(profile, { dishId, sense }) {
  const bp = _guestBp(profile);
  const dishLikes = bp.dishLikes.filter((x) => x !== dishId);
  const dishDislikes = bp.dishDislikes.filter((x) => x !== dishId);
  if (sense === 'like') dishLikes.push(dishId);
  if (sense === 'dislike') dishDislikes.push(dishId);
  // « J'aime » ou annulation : leve la mauvaise note, comme applyDishSense.
  const lowRatedDishes = sense === 'dislike'
    ? [...(bp.lowRatedDishes || [])]
    : (bp.lowRatedDishes || []).filter((x) => x !== dishId);
  return { ...profile, blockPreferences: { ...bp, dishLikes, dishDislikes, lowRatedDishes } };
}

export function toAccountPayload(state) {
  const profiles = (state.guestProfiles || []).map((p) => ({
    name: p.name,
    ageGroup: p.ageGroup || 'adult',
    regime: p.regime || 'Omnivore',
    allergies: p.allergies || {},
    aversions: p.aversions || '',
    tastePicks: p.tastePicks || {},
    blockPreferences: p.blockPreferences || emptyBlockPreferences(),
    objectives: p.objectives || {},
    isDefault: !!p.isDefault
  }));
  return { profiles, orderDraft: state.orderDraft || { mealsByProfileKey: {}, extras: [] } };
}

// Reconstruit la liste des profils invites a partir des prenoms du foyer.
// Le principal est preserve tel quel (ou cree par defaut), chaque prenom
// devient member-i (donnees existantes du meme index preservees), le surplus
// est purge.
export function memberProfilesFromNames(names, existingProfiles = []) {
  const principal = existingProfiles.find((p) => p.key === 'principal')
    || emptyGuestProfile({ key: 'principal', name: 'Moi', isDefault: true });
  const members = (names || []).map((n, i) => {
    const key = `member-${i}`;
    const existing = existingProfiles.find((p) => p.key === key);
    const base = existing || emptyGuestProfile({ key, name: n });
    return { ...base, key, name: n, isDefault: false };
  });
  return [principal, ...members];
}
